import { PlusOutlined } from '@ant-design/icons';
import { Modal, Checkbox, Row, Col, Button, Typography, Form, Input } from 'antd';
import React, { useEffect, useMemo, useState } from 'react';
import NumberFormat from 'react-number-format';
import { checklistAdditionalItems } from '../commondata/commonData';

function ChecklistAddItem({ addItems, setAddItems, checkListDataOnOffer }) {

    const [isCustomModalVisible, setIsCustomModalVisible] = useState(false);
    const [charityForm] = Form.useForm();

    const [selectedItems, setSelectedItems] = useState([]);
    const [customFieldCount, setCustomFieldCount] = useState(0);
    const [alreadyAddedItems, setAlreadyAddedItems] = useState([]);

    const filteredSelectedItems = useMemo(() => {
        return selectedItems.filter(
            (item) => !alreadyAddedItems.some((addedItem) => addedItem.name === item.name)
        );
    }, [selectedItems, alreadyAddedItems]);

    const handleCheckboxChange = (item, e) => {
        if (e.target.checked) {
            setSelectedItems((prev) => [...prev, item]);
        } else {
            setSelectedItems((prev) => prev.filter((selectedItem) => selectedItem.name !== item.name));
        }
    };

    const closeModal = () => {
        setAddItems({ ...addItems, addItemModalOpen: false })
    }

    const handleAddCustomItem = async () => {
        const values = await charityForm.validateFields();

        const newItem = {
            label: values.charityName,
            name: values.charityName,
            // value: values.charityValue,
            key: Date.now(),
            custom: true,
        };


        setAddItems((prev) => ({
            ...prev,
            addedItems: [...(prev.addedItems || []), newItem],
        }));

        setSelectedItems((prev) => [...prev, newItem]);

        charityForm.resetFields();
        setIsCustomModalVisible(false);
    };



    const handleAddItemsToChecklist = () => {
        const allItems = [...filteredSelectedItems];

        setAddItems({
            ...addItems,
            addedItems: allItems,
            addItemModalOpen: false,
        });
    };


    return (
        <div>
            <Modal
                open={addItems?.addItemModalOpen}
                okText="Add"
                onOk={handleAddItemsToChecklist}
                onCancel={closeModal}
                title={<div className='commonModalTitle'>SELECT ITEMS TO ADD</div>}
                okButtonProps={{ disabled: (filteredSelectedItems?.length === 0 && customFieldCount === 0) }}
            >
                <div>
                    <Row>
                        {[
                            ...checklistAdditionalItems.filter(
                                (item) => !Object.keys(checkListDataOnOffer?.commissionDistribution?.otherCommission || {}).includes(item?.name)
                            ),
                            ...selectedItems?.filter(el => el.custom),
                        ]?.map((item) => (
                            <Col span={24} key={item.id}>
                                <Checkbox
                                    checked={selectedItems.some((selectedItem) => selectedItem.id === item.id)}
                                    onChange={(e) => handleCheckboxChange(item, e)}
                                    style={{ fontSize: 16 }}
                                >
                                    <span>{item.label}</span>
                                </Checkbox>
                            </Col>
                        ))}
                    </Row>
                    <Row style={{ marginTop: 10 }} gutter={15}>
                        <Col>
                            <Typography.Text style={{ fontSize: 16 }}>Add Custom Field</Typography.Text>
                        </Col>
                        <Col>
                            <Button
                                type="dashed"
                                icon={<PlusOutlined />}
                                size="small"
                                onClick={() => setIsCustomModalVisible(true)}
                            />
                        </Col>
                    </Row>
                </div>
            </Modal>

            <Modal
                title={<span className='commonModalTitle'>Add Custom Field</span>}
                open={isCustomModalVisible}
                onOk={handleAddCustomItem}
                onCancel={() => setIsCustomModalVisible(false)}
                okText="Add"
            >
                <Form form={charityForm} layout="vertical">
                    <Form.Item
                        label="Field Label"
                        name="charityName"
                        rules={[{ required: true, message: 'Please enter the label name' }]}
                    >
                        <Input placeholder="Enter label" />
                    </Form.Item>

                    {/* <Form.Item
                        label="Field Value"
                        name="charityValue"
                        rules={[{ required: true, message: 'Please enter the value' }]}
                    >
                        <NumberFormat
                            className="newNumberInput"
                            inputMode="numeric"
                            displayType="input"
                            thousandSeparator={true}
                            prefix={"$ "}
                            suffix={".00"}
                            allowNegative={false}
                            customInput={Input}
                            placeholder="Enter amount"
                        />
                    </Form.Item> */}
                </Form>
            </Modal>

        </div>
    );
}

export default ChecklistAddItem;